module.exports = __webpack_public_path__ + "img/preview-11.48be8206.png";